import React, { Component } from 'react';
import { graphql } from 'gatsby';
import { Layout, SliceZone } from '../components';

class SupportUs extends Component {
  render() {
    const {
      data: {
        site: {
          siteMetadata,
        },
        page: {
          data: pageData,
        },
      },
      location,
    } = this.props;
    const {
      metaTitle,
      metaDescription,
      openGraphImage,
      body,
    } = pageData;
    const seoData = {
      metaTitle,
      metaDescription,
      openGraphImage,
    };
    return (
      <Layout location={location} seoData={seoData}>
        <SliceZone
          allSlices={body}
          siteMetadata={siteMetadata}
          location={location}
        />
      </Layout>
    );
  }
}

export default SupportUs;

export const pageQuery = graphql`
  query SupportUsQuery {
    site {
      siteMetadata {
        blogSlug,
      }
    },
    page: prismicSupportUs {
      uid,
      data {
        metaTitle: meta_title {
          html
          text
        },
        metaDescription: meta_description {
          html
          text
        },
        openGraphImage: open_graph_image {
          alt
          copyright
          url
        }
        body {
          ... on PrismicSupportUsBodyPageHero {
            id
            sliceType: slice_type
            primary {
              headline {
                text
              }
              subtitle {
                text
              }
              illustrationStyle: illustration_style
              illustrator {
                document {
                  ... on PrismicArtist {
                    data {
                      name {
                        text
                      }
                    }
                  }
                }
              }
              description {
                text
              }
              illustration {
                fluid(maxWidth: 1200) {
                  ...GatsbyPrismicImageFluid_withWebp
                }
                alt
              }
              theme
            }
          }
          ... on PrismicSupportUsBodyTextHero {
            id
            sliceType: slice_type
            primary {
              theme
              headline {
                text
                html
              }
              description {
                text
                html
              }
            }
            items {
              buttonLabel: button_label {
                text
              }
              buttonLink: button_link {
                url
              }
            }
          }
          ... on PrismicSupportUsBodyCallToActionTiles {
            id
            sliceType: slice_type
            primary {
              itemsPerRow: items_per_row
            }
            items {
              image {
                fluid(maxWidth: 1200) {
                  ...GatsbyPrismicImageFluid_withWebp
                }
                alt
              }
              title {
                text
                html
              }
              description {
                text
                html
              }
              buttonLabel: button_label {
                text
              }
              buttonLink: button_link {
                url
              }
            }
          }
          ... on PrismicSupportUsBodyResourceTiles {
            id
            sliceType: slice_type
            primary {
              theme
            }
            items {
              image {
                fluid(maxWidth: 1200) {
                  ...GatsbyPrismicImageFluid_withWebp
                }
                alt
              }
              title {
                text
                html
              }
              description {
                text
                html
              }
              buttonLabel: button_label {
                text
              }
              buttonLink: button_link {
                url
              }
            }
          }
          ... on PrismicSupportUsBodyImageBlock {
            id
            sliceType: slice_type
            primary {
              theme
              image {
                fluid(maxWidth: 1200) {
                  ...GatsbyPrismicImageFluid_withWebp
                }
                alt
              }
            }
          }
          ... on PrismicSupportUsBodyVideoBlock {
            id
            sliceType: slice_type
            primary {
              theme
              videoProvider: video_provider
              videoUrl: video_url {
                url
              }
            }
            items {
              buttonLabel: button_label {
                text
              }
              buttonLink: button_link {
                url
              }
            }
          }
        }
      }
    }
  }
`;
